module.exports = __webpack_public_path__ + "static/media/linkedin.4a69352e.svg";